import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import TextField from '@material-ui/core/TextField';
import { styled } from '@material-ui/core';

import { MODE, validMode } from '../utils/mode';

const BlackTextField = styled(TextField)(
  ({ readonlystyle, textalign, mode, nolabel }) => {
    return {
      marginBottom: 4,
      'input.MuiInput-input.MuiInputBase-input': {
        opacity: 1,
        WebkitTextFillColor: 'black',
        TextFillColor: 'black',
      },
      '.css-ghsjzk-MuiInputBase-root-MuiInput-root':
        readonlystyle === 'true'
          ? {
              '&:before': {
                borderBottomStyle: 'none !important',
                borderBottom: 'none !important',
              },
            }
          : undefined,
      label: {
        fontWeight: readonlystyle === 'true' ? 'bold' : '',
        display: nolabel === 'true' ? 'none' : 'block',
      },
      input: {
        paddingTop: 6,
        textAlign: textalign,
        display: mode !== MODE.VIEW ? 'block' : 'none',
      },
    };
  }
);

const VariableTextField = ({
  name,
  text,
  locked,
  textAlign,
  mode,
  noLabel,
  displayInSmall,
  ...properties
}) => {
  const [textValue, setTextValue] = useState(text);

  const onChangeValue = (event) => {
    setTextValue(event.target.value);
  };

  useEffect(() => {
    if (textValue == null) {
      setTextValue(text);
    }
  }, [textValue, text]);

  return (
    <>
      {mode && validMode(mode) ? (
        <>
          {noLabel && mode === MODE.VIEW ? undefined : (
            <BlackTextField
              className="black-text-field"
              name={!locked ? name : undefined}
              fullWidth
              variant="standard"
              size={displayInSmall ? 'small' : ''}
              value={textValue ? textValue : mode === MODE.VIEW ? ' ' : ''}
              InputProps={{
                readOnly: mode === MODE.VIEW || locked,
              }}
              readonlystyle={mode === MODE.VIEW || locked ? 'true' : 'false'}
              required={mode === MODE.EDIT}
              textalign={textAlign}
              mode={mode}
              onChange={onChangeValue}
              nolabel={noLabel ? 'true' : 'false'}
              focused={mode === MODE.VIEW || locked ? false : undefined}
              {...properties}
            />
          )}
          {mode === MODE.VIEW ? textValue : undefined}
          {locked ? (
            <TextField
              name={name}
              value={textValue ? textValue : mode === MODE.VIEW ? ' ' : ''}
              sx={{ display: 'none' }}
              {...properties}
            />
          ) : undefined}
        </>
      ) : undefined}
    </>
  );
};

VariableTextField.propTypes = {
  name: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  locked: PropTypes.bool,
  mode: PropTypes.string,
  textAlign: PropTypes.string,
  noLabel: PropTypes.bool,
  displayInSmall: PropTypes.bool,
};

VariableTextField.defaultProps = {
  name: '',
  text: '',
  locked: false,
  mode: MODE.VIEW,
  textAlign: '',
  noLabel: false,
  displayInSmall: true,
};

export default VariableTextField;
